"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shortenerUtil = void 0;
var _indi = require("../indi");
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class shortenerUtil {
  static shorten(url, callback) {
    _indi.indi.post(shortenerUtil.endpoints.shorten, url, response => {
      if (response.isError) {
        //Fail
        callback(response);
      } else {
        //Success (parse down to only arrary of data)
        callback(response);
      }
    });
  }
}
exports.shortenerUtil = shortenerUtil;
_defineProperty(shortenerUtil, "endpoints", {
  shorten: "/s/shorten"
});
;